// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalCreateQualiphyProcedure_root__1jWMB","footer":"ModalCreateQualiphyProcedure_footer__1qouh","additionData":"ModalCreateQualiphyProcedure_additionData__3v2HQ"};